import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { PlansHeader } from './PlansHeader';
import { PlansFooter } from './PlansFooter';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    root: {
      background: '#F3F4F6 !important',
      flexGrow: 1,
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
  }),
);

type LayoutProps = {
  children: React.ReactNode;
};
export const PlansLayout: React.FC<LayoutProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <PlansHeader />
      <div className={classes.root}>{children}</div>
      <PlansFooter />
    </div>
  );
};
